export function getPermitEndTime(permitEnd) {
  return Date.parse(`${permitEnd.substring(0, 4)}/${permitEnd.substring(4, 6)}/${permitEnd.substring(6, 8)} 00:00:00 +0900`)
}

export function visibleBookLimitDate(book) {
  // 閲覧可能時間はpublish_end_dateのみをみる
  return Date.parse(book.publish_end_date)
}

export function isVisibleBook(book, currentTime) {
  let visible = true
  const limitDate = visibleBookLimitDate(book)

  // 閲覧期限付コンテンツは期限が過ぎたら除外
  if (book.read_period_content_flag && limitDate && currentTime > limitDate) {
    visible = false
  }

  return visible
}

export function getEndDate(book) {
  if (book.read_period_content_flag) {
    const downloadEnd = new Date(book.publish_end_date)
    return `${downloadEnd.getFullYear()}年${downloadEnd.getMonth() + 1}月${downloadEnd.getDate()}日${`0${downloadEnd.getHours()}`.slice(
      -2,
    )}:${`0${downloadEnd.getMinutes()}`.slice(-2)}`
  }

  return null
}
